import { ApiResponse, ResponseTransform } from '~domain/api-clients/base-client';
import { getReturnUrl } from '~web-portal/helpers/get-return-url';
import { useAuthStore } from '~web-portal/stores';
import { Paths } from '~web-portal/variables/paths';

/**
 * Response transform that logs the user out if the request fails and doesn't fall into one of the exceptions
 */
export const logoutResponseTransform: ResponseTransform = (response: ApiResponse<any>) => {
  // Check if the request failed
  if (!response.ok) {
    const { status, config } = response;

    // Logout on 401 or 403, but exclude specific cases
    const exclusions: (() => boolean)[] = [
      // don't logout if the passwordless validation fails. We show a custom error message instead.
      () => config?.url?.includes('/passwordless/validate'),

      // don't logout when we're already in login page
      () => window.location.pathname === Paths.login.path,
    ];

    // Logout if the response status is 401 or 403, and at least one of the exclusions matches
    const isExcluded = exclusions.some((f) => f());
    if ((status === 401 || status === 403) && !isExcluded) {
      // clear auth infos
      useAuthStore.getState().clearAuth();

      // redirect to login page with current page as returnUrl
      const returnUrl = getReturnUrl();
      window.location.href = `${Paths.login.path}?${Paths.login.urlParams.returnUrl}=${encodeURIComponent(returnUrl)}`;
    }
  }
};
